import { useFeatureFlag } from "../../../lib/delivery";

interface RequireFeatureFlagProps {
  /** The Statsig gate name, from `FeatureFlags` in `lib/delivery_keys`. */
  flag: string;
  children: React.ReactNode;
  /** Rendered when the flag is off or not yet loaded. Defaults to null. */
  fallback?: React.ReactNode;
}

/** Renders children only while the feature flag is on for the current user. */
export function RequireFeatureFlag({ flag, children, fallback = null }: RequireFeatureFlagProps) {
  const enabled = useFeatureFlag(flag);
  return enabled ? <>{children}</> : <>{fallback}</>;
}
